import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateContacto = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/contactos/${params.emp_id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearContactoMutation: mutation.mutate,
    };
}